import { render } from "./FacultyAdminLoadDialog.vue?vue&type=template&id=411ec4c4"
import script from "./FacultyAdminLoadDialog.vue?vue&type=script&lang=js"
export * from "./FacultyAdminLoadDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__